// 「道具 ▸」の小窓の縦位置。ボタンと同じ高さに出し、下にはみ出す分だけ上へ寄せる。
// 「道具 ▸」はサイドバーの下の方にあり、ボタンの横 (キャンバス側) の下はチャット欄なので、
// 小窓の横幅がチャット欄にかかるときはチャット欄の上端を下限にする (重ねない)。

export interface FlyoutPlacementInput {
  /** 「道具 ▸」ボタンの上端。 */
  readonly anchorTop: number;
  /** 小窓の実測の高さ。 */
  readonly height: number;
  /** 小窓の左右 (横がチャット欄にかかるかの判定用)。 */
  readonly left: number;
  readonly right: number;
  readonly viewportHeight: number;
  /** チャット欄の矩形 (見つからなければ null)。 */
  readonly chat: { readonly top: number; readonly left: number; readonly right: number } | null;
}

const MARGIN = 4;

export const placeToolsFlyoutTop = (i: FlyoutPlacementInput): number => {
  let bottomLimit = i.viewportHeight - MARGIN;
  const c = i.chat;
  if (c !== null && c.left < i.right && c.right > i.left) {
    bottomLimit = Math.min(bottomLimit, c.top - MARGIN);
  }
  return Math.max(MARGIN, Math.min(i.anchorTop, bottomLimit - i.height));
};
